<template>
  <!-- 初始状态下隐藏提示框 -->
  <transition name="fade">
    <div class="cus-confirm" :class="config.customClass" v-if="isShow">
      <!-- 背景遮罩 -->
      <div class="mask" @click="closeMask"></div>
      <div class="confirm-box">
        <div class="close-icon" @click="handleClose"><img src="../../static/img/close.png" alt=""></div>
        <div class="title-box" v-if="config.title">{{ config.title }}</div>
        <div class="content-box" v-html="config.message"></div>
        <div class="btn-box">
          <div class="btn confirm" @click="handleConfirm">
            {{ config.confirmButtonText }}
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Alert',
  data () {
    return {
      isShow: false,
      config: {
        title: '提示', // 弹窗标题
        message: '', // 弹窗内容
        confirmButtonText: '确定', // 按钮文案
        customClass: '',
        // eslint-disable-next-line no-empty-function
        onConfirm: () => {},
        onClose: () => {}
      }
    }
  },
  methods: {
    // 关闭弹窗
    close () {
      this.isShow = false;
    },
    handleClose () {
      this.config.onClose();
      this.close();
    },
    closeMask () {
      this.close();
    },
    handleConfirm () {
      this.config.onConfirm();
      this.close();
    }
  }
};
</script>
<style scoped>
.confirm-box {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 60%;
  min-height: 8rem;
  line-height: 1rem;
  padding: 1rem;
  background-color: #fff;
  border-radius: .125rem;
  border: .0625rem solid rgba(255, 255, 255, 1);
  z-index: 3001;
}

.close-icon {
  position: absolute;
  right: .8rem;
  top: .8rem;
}
.close-icon img{
  width: 0.8rem;
  height: 0.8rem;
}

.title-box {
  text-align: center;
  font-size: 1rem;
  color: #000;
  margin-bottom: 0.5rem;
}

.content-box {
  font-size: .875rem;
  color: rgba(0, 0, 0, 0.85);
  padding: .625rem 0;
}
.btn-box {
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn {
  width: 70%;
  height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: .875rem;
  padding: 0 .625rem;
  text-align: center;
  position: absolute;
  bottom: .875rem;
  border-radius: .25rem;
  font-size: .875rem;
}
.confirm {
  background: linear-gradient(180.00deg, rgb(58, 126, 255),rgb(33, 109, 254) 100%);
  color: #fff;
  cursor: pointer;
}
  
.mask {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  left: 0;
  top: 0;
  overflow: hidden;
  z-index: 3000;
}
</style>



// WEBPACK FOOTER //
// src/components/Confirm/index.vue